import { render, staticRenderFns } from "./home-my-projects.component.vue?vue&type=template&id=702288a6&scoped=true&"
import script from "./home-my-projects.component.vue?vue&type=script&lang=ts&"
export * from "./home-my-projects.component.vue?vue&type=script&lang=ts&"
import style0 from "./home-my-projects.component.vue?vue&type=style&index=0&id=702288a6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702288a6",
  null
  
)

export default component.exports